export const GET_PAYMENTS_PLANNED_PAGINATION =
  "[PAYMENTS_PLANNED] Pagination Get";
export const GET_PAYMENTS_PLANNED_PAGINATION_SUCCESS =
  "[PAYMENTS_PLANNED] Pagination Get Success";
export const GET_PAYMENTS_PLANNED_PAGINATION_FAIL =
  "[PAYMENTS_PLANNED] Pagination Get Fail";

export const CREATE_PLANNED_PAYMENT =
  "[PAYMENTS_PLANNED] Create Planned Payment";
export const CREATE_PLANNED_PAYMENT_SUCCESS =
  "[PAYMENTS_PLANNED] Create Planned Payment Success";
export const CREATE_PLANNED_PAYMENT_FAIL =
  "[PAYMENTS_PLANNED] Create Planned Payment Fail";

export const UPDATE_PLANNED_PAYMENT =
  "[PAYMENTS_PLANNED] Update Planned Payment";
export const UPDATE_PLANNED_PAYMENT_SUCCESS =
  "[PAYMENTS_PLANNED] Update Planned Payment Success";
export const UPDATE_PLANNED_PAYMENT_FAIL =
  "[PAYMENTS_PLANNED] Update Planned Payment Fail";

export const DELETE_PLANNED_PAYMENT =
  "[PAYMENTS_PLANNED] Delete Planned Payment";
export const DELETE_PLANNED_PAYMENT_SUCCESS =
  "[PAYMENTS_PLANNED] Delete Planned Payment Success";
export const DELETE_PLANNED_PAYMENT_FAIL =
  "[PAYMENTS_PLANNED] Delete Planned Payment Fail";

export const GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS =
  "[PAYMENTS_PLANNED] Get Has Active Payment Automation Configurations";
export const GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS_SUCCESS =
  "[PAYMENTS_PLANNED] Get Has Active Payment Automation Configurations Success";
export const GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS_FAIL =
  "[PAYMENTS_PLANNED] Get Has Active Payment Automation Configurations Fail";
